import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import {
  aboutActivityIcon,
  aboutDrinksIcon,
  aboutFoodsIcon,
  aboutFurnitureIcon,
  aboutHostRulesIcon,
  aboutMusicIcon,
  aboutParkingIcon,
  aboutRestroomIcon,
  aboutRulesIcon,
} from "../../Constants/Images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { SpaceTypes } from "../../Constants/Interfaces";
import AboutAccordian from "./AboutAccordian";

interface AboutTabType {
  item: SpaceTypes;
}

const AboutTab: React.FC<AboutTabType> = ({ item }) => {
  const [readMore, setReadMore] = useState(false);

  return (
    <div className="about-tab-wrapper">
      <div className="about-content">
        <h2>About {item.name ? item.name : ""}</h2>
        {!readMore && <p>{String(item.description).substring(0, 250)}...</p>}
        {readMore && <p>{item.description}</p>}

        <span
          className="read-more-link as-link"
          onClick={() => setReadMore(!readMore)}
        >
          Read {!readMore ? "more" : "less"}
        </span>
      </div>

      <AboutAccordian type="about" details={item.details} />
    </div>
  );
};

export default AboutTab;
